import { Container } from '@mui/material';
import { FC } from 'react';
import { OneColumnContainer, Text } from '~/components';

const NotFoundPage: FC = () => (
  <OneColumnContainer>
    <Container sx={{ py: '20vh' }} maxWidth='sm'>
      <Text align='center'>Página não Encontrada</Text>
    </Container>
  </OneColumnContainer>
);

export default NotFoundPage;
